let _ = t => t,
  _t;
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledPill = styledWithTheme.div(_t || (_t = _`
  position: absolute;
  top: -3px;
  width: ${0}%;
  min-width: 8px;
  left: ${0}%;
  margin-left: -4px;
  background: ${0};
  border: 1px solid ${0};
  height: 8px;
  border-radius: 4px;
  cursor: pointer;
  ${0};
`), ({
  width
}) => width, ({
  left
}) => left, ({
  fillColor,
  theme
}) => theme.color[fillColor], ({
  borderColor,
  theme
}) => theme.color[borderColor], ({
  interactable
}) => interactable && 'z-index : 1');
const TimelinePill = props => {
  const {
    pill
  } = props;
  return /*#__PURE__*/_jsx(StyledPill, {
    fillColor: pill.fillColor,
    borderColor: pill.borderColor,
    width: pill.width,
    left: pill.startLocation,
    interactable: !!pill.onPillClick || !!pill.onPillHover,
    "data-test-id": "mediaTimeline-timelinePill",
    onClick: pill.onPillClick,
    onMouseOver: pill.onPillHover,
    onMouseOut: pill.onPillUnhover
  });
};
export default TimelinePill;